export const parseMap = (mapString) => {
  if (!mapString) {
    return null;
  }
  const [coords] = mapString.split('@');
  const [lat, lng] = coords.split(':').map(Number);
  return { lat, lng };
};
